export default __webpack_public_path__ + "static/media/phaphrom_img7.986b9ae1.webp";